"use strict";

var Ajaxinate = function (config) {
  var settings = config || {};
  this.settings = Object.assign(
    {
      pagination: "#pagination-wrapper",
      method: "scroll",
      container: "#product-grid",
      offset: 700,
      prefetchOffset: 1200,
      loadingText: "טוען...",
      async: true,
      callback: null,
      sectionId: null,
    },
    settings
  );

  this.isLoading = false;
  this.prefetchPromise = null;
  this.prefetchUrl = null;
  this.scrollRaf = null;

  this.onScroll = this.onScroll.bind(this);
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  if (!this.settings.sectionId && this.containerElement && this.containerElement.dataset.id) {
    this.settings.sectionId = this.containerElement.dataset.id;
  }

  this.initialize();
};

Ajaxinate.prototype.initialize = function () {
  if (!this.containerElement) return;

  var methodHandlers = {
    click: this.addClickListener,
    scroll: this.addScrollListeners,
  };

  if (methodHandlers[this.settings.method]) {
    methodHandlers[this.settings.method]();
  }
};

Ajaxinate.prototype.buildFetchUrl = function (pageUrl) {
  if (!this.settings.sectionId) return pageUrl;

  var url = new URL(pageUrl, window.location.origin);
  url.searchParams.set("section_id", this.settings.sectionId);
  return url.toString();
};

Ajaxinate.prototype.addScrollListeners = function () {
  if (!this.paginationElement) return;

  document.addEventListener("scroll", this.onScroll, { passive: true });
  window.addEventListener("resize", this.onScroll);
  window.addEventListener("orientationchange", this.onScroll);
  this.checkIfPaginationInView();
};

Ajaxinate.prototype.onScroll = function () {
  if (this.scrollRaf) return;

  this.scrollRaf = requestAnimationFrame(
    function () {
      this.scrollRaf = null;
      this.checkIfPaginationInView();
    }.bind(this)
  );
};

Ajaxinate.prototype.addClickListener = function () {
  if (!this.paginationElement) return;

  this.nextPageLinkElement = this.paginationElement.querySelector("a");
  this.clickActive = true;

  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.stopMultipleClicks = function (event) {
  event.preventDefault();

  if (!this.clickActive || this.isLoading) return;

  this.nextPageLinkElement.innerHTML = this.settings.loadingText;
  this.nextPageUrl = this.nextPageLinkElement.href;
  this.clickActive = false;
  this.loadMore();
};

Ajaxinate.prototype.prefetchNextPage = function () {
  if (!this.paginationElement || this.isLoading || this.prefetchPromise) return;

  var link = this.paginationElement.querySelector("a");
  if (!link) return;

  var url = this.buildFetchUrl(link.href);
  if (this.prefetchUrl === url) return;

  this.prefetchUrl = url;
  this.prefetchPromise = fetch(url)
    .then(function (response) {
      if (!response.ok) throw new Error("Prefetch failed");
      return response.text();
    })
    .catch(
      function () {
        this.prefetchPromise = null;
        this.prefetchUrl = null;
      }.bind(this)
    );
};

Ajaxinate.prototype.checkIfPaginationInView = function () {
  if (!this.paginationElement || this.isLoading) return;

  var rect = this.paginationElement.getBoundingClientRect();
  var triggerLine = window.innerHeight + this.settings.offset;
  var prefetchLine = window.innerHeight + this.settings.prefetchOffset;

  if (rect.top <= prefetchLine && rect.bottom >= 0) {
    this.prefetchNextPage();
  }

  if (rect.top <= triggerLine && rect.bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    if (!this.nextPageLinkElement) return;

    this.removeScrollListener();
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.loadMore();
  }
};

Ajaxinate.prototype.parseFetchedHtml = function (html) {
  var doc = new DOMParser().parseFromString(html, "text/html");
  var containerSelector = this.settings.container;
  var paginationSelector = this.settings.pagination;

  return {
    containerContent: doc.querySelector(containerSelector),
    paginationContent: doc.querySelector(paginationSelector),
  };
};

Ajaxinate.prototype.initQuickAddForNewItems = function (previousCount) {
  if (typeof theme === "undefined" || typeof theme.QuickAdd !== "function") return;

  var newItems = Array.prototype.slice.call(this.containerElement.children, previousCount);
  newItems.forEach(function (item) {
    new theme.QuickAdd(item);
  });
};

Ajaxinate.prototype.loadMore = async function () {
  if (this.isLoading) return;

  this.isLoading = true;
  var fetchUrl = this.buildFetchUrl(this.nextPageUrl);

  try {
    var html;

    if (this.prefetchPromise && this.prefetchUrl === fetchUrl) {
      html = await this.prefetchPromise;
    } else {
      var response = await fetch(fetchUrl);
      if (!response.ok) throw new Error("Network response was not ok");
      html = await response.text();
    }

    this.prefetchPromise = null;
    this.prefetchUrl = null;

    var parsed = this.parseFetchedHtml(html);
    if (!parsed.containerContent) throw new Error("Product grid not found in response");

    var previousCount = this.containerElement.children.length;
    this.containerElement.insertAdjacentHTML("beforeend", parsed.containerContent.innerHTML);
    this.initQuickAddForNewItems(previousCount);

    if (!parsed.paginationContent || !parsed.paginationContent.querySelector("a")) {
      var wrapper = document.querySelector("#pagination-wrapper");
      if (wrapper) wrapper.remove();
      this.paginationElement = null;
    } else {
      this.paginationElement.innerHTML = parsed.paginationContent.innerHTML;

      if (this.settings.callback && typeof this.settings.callback === "function") {
        var doc = new DOMParser().parseFromString(html, "text/html");
        this.settings.callback(doc);
      }

      this.initialize();
    }
  } catch (error) {
    console.error("Ajaxinate load error:", error);
    this.prefetchPromise = null;
    this.prefetchUrl = null;
    this.initialize();
  } finally {
    this.isLoading = false;
  }
};

Ajaxinate.prototype.removeClickListener = function () {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.removeScrollListener = function () {
  document.removeEventListener("scroll", this.onScroll);
  window.removeEventListener("resize", this.onScroll);
  window.removeEventListener("orientationchange", this.onScroll);

  if (this.scrollRaf) {
    cancelAnimationFrame(this.scrollRaf);
    this.scrollRaf = null;
  }
};

Ajaxinate.prototype.destroy = function () {
  var methodHandlers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };

  if (methodHandlers[this.settings.method]) {
    methodHandlers[this.settings.method]();
  }

  return this;
};
